module.exports = __webpack_public_path__ + "components/rewards-header/static/unlock-black-02b3741d59985b3f25bc2bee4d197793.svg";